import React from "react";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import PageHeader from "modules/common/PageHeader";

const EcomStatItem = ({
  stat,
  setSelectedGraphKey,
  setSelectedCountKey,
  selectedGraphKey,
}) => {
  return (
    <Col className={`${stat.className} ms-n3`}>
      <div className="">
        <div
          className={`d-flex flex-row justify-content-evenly cursor-pointer w-75 ${
            selectedGraphKey == stat.totalGraphKey ? `text-primary` : null
          }`}
          onClick={() => {
            setSelectedGraphKey(stat.totalGraphKey);
            setSelectedCountKey(stat.totalCountKey);
          }}
        >
          <div>
            <div
              className="pb-1"
              style={{ fontFamily: "sans-serif" }}
            >
              {stat.title}
            </div>
            <p className="font-sans-serif lh-1 mb-1 fs-2">
              {stat.amount.toFixed(2)}
            </p>
            <div className="d-flex align-items-center">
              <h6 className="fs--1 text-500 mb-0">
                {stat.subAmount.toFixed(2)}
              </h6>
              <h6
                className={classNames("fs--2 ps-3 mb-0", {
                  "text-success": stat.type === "up",
                  "text-danger": stat.type === "down",
                  "text-primary": stat.type === "standard",
                  "text-warning": stat.type === "warning",
                  "text-info": stat.type === "pending",
                })}
              >
                <FontAwesomeIcon
                  icon={
                    stat?.amount > stat?.subAmount ? "caret-up" : "caret-down"
                  }
                  className={
                    stat?.amount < stat?.subAmount ? "me-1 text-danger" : "me-1"
                  }
                />
                {stat.percent}%
              </h6>
            </div>
          </div>
          <div className="cursor-pointer">
            <div
              className="pb-1"
              style={{ fontFamily: "sans-serif" }}
            >
              Order
            </div>
            <p className="font-sans-serif lh-1 mb-1 fs-2">{stat.totalCount}</p>
            <div className="d-flex align-items-center">
              <h6 className="fs--1 text-500 mb-0">
                {stat.totalSubCount.toFixed(2)}
              </h6>
              <h6
                className={classNames("fs--2 ps-3 mb-0", {
                  "text-success": stat.type === "up",
                  "text-danger": stat.type === "down",
                  "text-primary": stat.type === "standard",
                  "text-warning": stat.type === "warning",
                  "text-info": stat.type === "pending",
                })}
              >
                <FontAwesomeIcon
                  icon={
                    stat?.totalCount > stat?.totalSubCount
                      ? "caret-up"
                      : "caret-down"
                  }
                  className={
                    stat?.totalCount < stat?.totalSubCount
                      ? "me-1 text-danger"
                      : "me-1"
                  }
                />
                {stat.totalPercent}%
              </h6>
            </div>
          </div>
        </div>
        <div
          className={`d-flex justify-content-evenly border-top w-75 cursor-pointer ${
            selectedGraphKey == stat.newGraphKey ? `text-primary` : null
          }`}
          onClick={() => {
            setSelectedGraphKey(stat.newGraphKey);
            setSelectedCountKey(stat.newCountKey);
          }}
        >
          <div className="">
            <div>New</div>
            <p className="font-sans-serif lh-1 mb-1 fs-2">
              {stat.newAmount.toFixed(2)}
            </p>
            <div className="d-flex align-items-center">
              <h6 className="fs--1 text-500 mb-0">
                {stat.newSubAmount.toFixed(2)}
              </h6>
              <h6
                className={classNames("fs--2 ps-3 mb-0", {
                  "text-success": stat.type === "up",
                  "text-danger": stat.type === "down",
                  "text-primary": stat.type === "standard",
                  "text-warning": stat.type === "warning",
                  "text-info": stat.type === "pending",
                })}
              >
                <FontAwesomeIcon
                  icon={
                    stat?.newAmount > stat?.newSubAmount
                      ? "caret-up"
                      : "caret-down"
                  }
                  className={
                    stat?.newAmount < stat?.newSubAmount
                      ? "me-1 text-danger"
                      : "me-1"
                  }
                />
                {stat.newPercent}%
              </h6>
            </div>
          </div>
          <div>
            <div>Order</div>
            <p className="font-sans-serif lh-1 mb-1 fs-2">
              {stat.newCount.toFixed(2)}
            </p>
            <div className="d-flex align-items-center">
              <h6 className="fs--1 text-500 mb-0">
                {stat.newSubCount.toFixed(2)}
              </h6>
              <h6
                className={classNames("fs--2 ps-3 mb-0", {
                  "text-success": stat.type === "up",
                  "text-danger": stat.type === "down",
                  "text-primary": stat.type === "standard",
                  "text-warning": stat.type === "warning",
                  "text-info": stat.type === "pending",
                })}
              >
                <FontAwesomeIcon
                  icon={
                    stat?.newCount > stat?.newSubCount
                      ? "caret-up"
                      : "caret-down"
                  }
                  className={
                    stat?.newCount < stat?.newSubCount
                      ? "me-1 text-danger"
                      : "me-1"
                  }
                />
                {stat.newPercentCount}%
              </h6>
            </div>
          </div>
        </div>
        <div
          className={`d-flex flex-row justify-content-evenly w-75 border-top cursor-pointer ${
            selectedGraphKey == stat.repeatGraphKey ? `text-primary` : null
          }`}
          onClick={() => {
            setSelectedGraphKey(stat.repeatGraphKey);
            setSelectedCountKey(stat.repeatCountKey);
          }}
        >
          <div>
            <div>Repeat</div>
            <p className="font-sans-serif lh-1 mb-1 fs-2">
              {stat.repeatAmount.toFixed(2)}
            </p>
            <div className="d-flex align-items-center">
              <h6 className="fs--1 text-500 mb-0">
                {stat.repeatSubAmount.toFixed(2)}
              </h6>
              <h6
                className={classNames("fs--2 ps-3 mb-0", {
                  "text-success": stat.type === "up",
                  "text-danger": stat.type === "down",
                  "text-primary": stat.type === "standard",
                  "text-warning": stat.type === "warning",
                  "text-info": stat.type === "pending",
                })}
              >
                <FontAwesomeIcon
                  icon={
                    stat?.repeatAmount > stat?.repeatSubAmount
                      ? "caret-up"
                      : "caret-down"
                  }
                  className={
                    stat?.repeatAmount < stat?.repeatSubAmount
                      ? "me-1 text-danger"
                      : "me-1"
                  }
                />
                {stat.repeatPercent}%
              </h6>
            </div>
          </div>
          <div>
            <div>order</div>
            <p className="font-sans-serif lh-1 mb-1 fs-2">
              {stat.repeatCount.toFixed(2)}
            </p>
            <div className="d-flex align-items-center">
              <h6 className="fs--1 text-500 mb-0">
                {stat.repeatSubCount.toFixed(2)}
              </h6>
              <h6
                className={classNames("fs--2 ps-3 mb-0", {
                  "text-success": stat.type === "up",
                  "text-danger": stat.type === "down",
                  "text-primary": stat.type === "standard",
                  "text-warning": stat.type === "warning",
                  "text-info": stat.type === "pending",
                })}
              >
                <FontAwesomeIcon
                  icon={
                    stat?.repeatCount > stat?.repeatSubCount
                      ? "caret-up"
                      : "caret-down"
                  }
                  className={
                    stat?.repeatCount < stat?.repeatSubCount
                      ? "me-1 text-danger"
                      : "me-1"
                  }
                />
                {stat.repeatPercentCount}%
              </h6>
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};

const FinancialData = ({
  data,
  setSelectedGraphKey,
  setSelectedCountKey,
  selectedGraphKey,
}) => {
  const chunkSize = 5;
  const chunkedData = [];
  for (let index = 0; index < data?.length; index += chunkSize) {
    chunkedData.push(data.slice(index, index + chunkSize));
  }
  return (
    <div style={{ width: "100%" }}>
      {chunkedData.map((chunk, rowIndex) => (
        <Row key={rowIndex} className="g-0" style={{ width: "100%" }}>
          <div className="d-flex gap-2 justify-content-between">
            {chunk.map((stat, index) => (
              <PageHeader className="mb-3" style={{ width: "100%" }}>
                <EcomStatItem
                  key={stat.title}
                  stat={stat}
                  index={rowIndex * chunkSize + index}
                  lastIndex={data.length - 1}
                  setSelectedGraphKey={setSelectedGraphKey}
                  setSelectedCountKey={setSelectedCountKey}
                  selectedGraphKey={selectedGraphKey}
                />
              </PageHeader>
            ))}
          </div>
        </Row>
      ))}
    </div>
  );
};

export default FinancialData;
